import { Menu, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './dropdown.module.scss';

const Dropdown = ({ children, content, style }) => (
  <div>
    <Menu as="div">
      <div>
        <Menu.Button className={styles.menuButton}>{children}</Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95">
        <Menu.Items className={styles.drop} style={style}>
          <div>{content}</div>
        </Menu.Items>
      </Transition>
    </Menu>
  </div>
);

Dropdown.propTypes = {
  children: PropTypes.node,
  content: PropTypes.node,
  style: PropTypes.object
};

export default Dropdown;
